import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-exclude-emails-modal',
  templateUrl: './exclude-emails-modal.component.html',
  styleUrls: ['./exclude-emails-modal.component.scss']
})
export class ExcludeEmailsModalComponent {
  excludedEmails: string = '';
  invalidEmails: string[] = [];
  allParsedEmails: string[] = [];
  hiddenEmails: string[] = [];
  dragging = false;
  validEmailsFromTextarea: string[] = [];
  invalidEmailsFromTextarea: string[] = [];
  isCsvFile = false;


  constructor(
    public dialogRef: MatDialogRef<ExcludeEmailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { initialEmails?: string[] }
  ) {}

  ngOnInit(): void {
    if (this.data?.initialEmails?.length) {
      this.allParsedEmails = this.data.initialEmails;
      this.hideEmailsOverPreviewCount(this.allParsedEmails);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragging = true;
  }

  onDragLeave(event: DragEvent): void {
    this.dragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files[0];
    if (file) {
      this.readCSVFile(file);
    }
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.readCSVFile(file);
    }
    this.isCsvFile = true;
  }

  readCSVFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const text = e.target.result;
      this.parseCSVAndFillTextarea(text);
    };
    reader.readAsText(file);
  }

  parseCSVAndFillTextarea(csvText: string): void {
    const lines = csvText.split('\n').map(line => line.trim()).filter(line => line);
    const headers = lines[0].split(',').map(h => h.trim().toLowerCase());

    const emailIndex = headers.findIndex(h => h === 'email');
    if (emailIndex === -1) {
      alert("CSV must contain a column named 'Email'");
      return;
    }

    const emails: string[] = [];
    const invalids: string[] = [];

    for (let i = 1; i < lines.length; i++) {
      const cols = lines[i].split(',');
      const email = cols[emailIndex]?.trim();
      if (email) {
        if (this.isValidEmail(email)) {
          emails.push(email);
        } else {
          invalids.push(email);
        }
      }
    }

    this.invalidEmails=invalids;


    this.hideEmailsOverPreviewCount(emails);
    this.allParsedEmails = emails;
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  clearTextarea(): void {
    this.excludedEmails = '';
    this.invalidEmails = [];
    this.hiddenEmails = [];
  }

  onSaveExcluded(): void {    
    this.allParsedEmails = this.excludedEmails
    .split('\n')
    .map(e => e.trim())
    .filter(e => this.isValidEmail(e));
    this.allParsedEmails = this.allParsedEmails.concat(this.hiddenEmails);
    this.dialogRef.close(this.allParsedEmails);
  }

  onClose(): void {
    if(this.isCsvFile)
    {
      this.excludedEmails = '';
      this.isCsvFile = false;
      this.dialogRef.close();
    }
    else{
     this.dialogRef.close(this.allParsedEmails);
    } 
  }

  hideEmailsOverPreviewCount(emails: string[]){
    const previewCount = 100;
    const preview = emails.slice(0, previewCount);
    const hiddenCount = emails.length - previewCount;
    this.hiddenEmails = emails.slice(previewCount);
    

    this.excludedEmails = preview.join('\n') +
      (hiddenCount > 0 ? `\n...and ${hiddenCount} more hidden` : '');
  }

  get hasValidEmails(): boolean {
    return this.validEmailsFromTextarea.length > 0 || this.allParsedEmails.length > 0;
  }

  onTextareaChange(text: string): void {
    const lines = text.split('\n').map(e => e.trim()).filter(e => e);

    const validEmails: string[] = [];
    const invalidEmails: string[] = [];
  
    for (const email of lines) {
      if (this.isValidEmail(email)) {
        validEmails.push(email);
      } else {
        invalidEmails.push(email);
      }
    }
  
    this.validEmailsFromTextarea = validEmails;
    this.invalidEmailsFromTextarea = invalidEmails;
  }
}
